import { jsx as _jsx } from "react/jsx-runtime";
import { DataGrid } from '@mui/x-data-grid';
import { palette } from '../../../../theme/palette';
const theme = palette('light');
export const SecondaryGrid = ({ rows, columns, h = 'calc(100svh - 290px)', noRowWidth }) => {
    const nonSortableColumns = columns.map((column) => ({
        ...column,
        sortable: false
    }));
    return (_jsx("div", { style: {
            height: h,
            width: '100%',
            background: 'white',
            borderRadius: '0px 0px 25px 25px'
        }, children: _jsx(DataGrid, { sx: {
                height: h,
                width: '100%',
                borderRadius: '25px',
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: theme.black.main,
                    color: '#ffffff',
                    borderRadius: '25px',
                    marginBottom: '15px'
                },
                '& .MuiDataGrid-cell': {
                    background: theme.common.white,
                    border: 'none',
                    paddingLeft: '16px',
                    paddingRight: '16px'
                },
                '& .MuiDataGrid-main': {
                    background: theme.background.neutral
                },
                '& .MuiDataGrid-virtualScroller': {
                    background: 'white',
                    borderRadius: '10px'
                },
                '& .MuiDataGrid-cell:focus': {
                    outline: 'none'
                },
                '& .MuiDataGrid-cell:focus-within': {
                    outline: 'none'
                },
                '& .MuiDataGrid-overlayWrapperInner ': {
                    width: `${noRowWidth}svw !important`,
                    textAlign: 'center !important',
                    height: 'calc(100svh - 450px) !important'
                }
            }, localeText: { noRowsLabel: 'No results found' }, rows: rows, columns: nonSortableColumns, disableColumnMenu: true, disableColumnFilter: true, disableColumnSelector: true, disableRowSelectionOnClick: true, hideFooterPagination: true, hideFooterSelectedRowCount: true, hideFooter: true }) }));
};
